import {
  WATCH_LIST_DEACTIVATION,
} from '../types';

import createAsyncActions from '../../../utilities/createAsyncActions';

export const {
  watchListDeactivation,
  watchListDeactivationPending,
  watchListDeactivationFulfilled,
  watchListDeactivationRejected,
} = createAsyncActions(WATCH_LIST_DEACTIVATION, 'watchListDeactivation');



// WEBPACK FOOTER //
// ./src/features/watch-list-entry/actions/watchListDeactivationAction.js